export default "__VITE_ASSET__DmlUyJ0y__"